// Profile of Alina Tselinina, Polish. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina jest inżynierką oprogramowania z doświadczeniem w inżynierii danych, matematyce stosowanej i uczeniu maszynowym, która obecnie pracuje nad aplikacjami opartymi na AI i systemami agentowymi. Ma doświadczenie w budowaniu API i potoków danych, modernizacji aplikacji poprzez migrację do chmury oraz tworzeniu usług opartych na ML. Koncentruje się na łączeniu LLM i agentów AI z niezawodnymi systemami oprogramowania za pomocą ustrukturyzowanych przepływów pracy, integracji, testowania i iteracyjnej ewaluacji.',
  imageAlt: 'Portret Aliny Tselininy',
  personal: {
    languages: 'Angielski, polski',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Studia: matematyka finansowa i aktuarialna',
      institution: 'Uniwersytet im. Adama Mickiewicza w Poznaniu',
      degree: 'Tytuł: magister'
    },
    {
      period: '2009 - 2014',
      field: 'Studia: matematyka',
      institution: 'Białoruski Uniwersytet Państwowy, Mińsk',
      degree: 'Tytuł: licencjat'
    }
  ],
  skills: [
    {
      title: 'Programowanie',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'AI i LLM',
      description: 'Claude, MCP, agenci AI, adaptacja LLM, trenowanie i ewaluacja modeli'
    },
    {
      title: 'Chmura i dane',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Frameworki i API',
      description: 'FastAPI, Flask, Shiny, REST API, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Inżynieria danych i DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Bazy danych i orkiestracja',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Narzędzia Atlassian',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'marzec 2026 - obecnie',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'Tworzenie agentów AI, konfiguracja przepływów pracy i integracja narzędzi.',
        'Adaptacja LLM oraz trenowanie i ewaluacja modeli.',
        'Tworzenie i integracja aplikacji opartych na AI.',
        'Obliczenia kwantowe: udział w tworzeniu oprogramowania dla aplikacji kwantowych.'
      ]
    },
    {
      period: 'maj 2025 - obecnie',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'Tworzenie aplikacji.',
        'Implementacja testów jednostkowych i testów UI wspierających jakość aplikacji.'
      ]
    },
    {
      period: 'listopad 2022 - luty 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Utrzymanie i ulepszanie potoków danych oraz orkiestracji przepływów pracy.',
        'Tworzenie pakietów do automatyzacji raportów.'
      ]
    },
    {
      period: 'lipiec 2022 - październik 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Tworzenie i utrzymanie potoków ETL.'
      ]
    },
    {
      period: 'marzec 2022 - czerwiec 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Projektowanie i tworzenie interfejsów REST API oraz usług backendowych.',
        'Implementacja logiki backendowej przetwarzającej JSON.'
      ]
    },
    {
      period: 'listopad 2020 - marzec 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Projektowanie i tworzenie interfejsów REST API oraz usług backendowych (proof of concept).',
        'Tworzenie i utrzymanie potoków ETL.',
        'Modernizacja aplikacji on-premise poprzez migrację do AWS i przepisanie kodu R na Python.',
        'Walidacja XML i transformacja do HTML.',
        'Tworzenie aplikacji webowych.'
      ]
    },
    {
      period: 'maj 2020 - listopad 2020',
      title: 'Data Scientist, PSI Polska, Poznań',
      description: [
        'Projektowanie i tworzenie interfejsów REST API oraz usług backendowych z modelem uczenia maszynowego w backendzie.',
        'Opracowanie modelu segmentacji klientów.'
      ]
    },
    {
      period: 'styczeń 2019 - kwiecień 2020',
      title: 'Advanced Data Scientist, Analyx, Poznań',
      description: [
        'Web scraping i tworzenie potoków danych.',
        'Tworzenie aplikacji webowych.',
        'Modelowanie marketing mix.',
        'Optymalizacja procesów pracy.'
      ]
    },
    {
      period: 'maj 2018 - grudzień 2018',
      title: 'Data Scientist, Poznań',
      description: [
        'Tworzenie procesu ETL.',
        'Utrzymanie skryptów Bash.',
        'Wsparcie klientów i analizy ad hoc.'
      ]
    },
    {
      period: 'kwiecień 2017 - kwiecień 2018',
      title: 'Junior Analyst, Poznań',
      description: [
        'Analiza danych i tworzenie raportów.',
        'Przygotowywanie dokumentacji i prezentacji.'
      ]
    }
  ]
};
